export default ($root = {}) => {
  const getError = () => $root.error

  const getSendLeadEmail = () => {
    const { sendLeadEmailLoading, sendLeadEmailError } = $root

    return {
      sendLeadEmailLoading,
      sendLeadEmailError,
    }
  }

  return { getSendLeadEmail, getError }
}
